<div class="page-header">
  <div class="page-container">
    <div class="page-header__content">
      <div class="page-header__info">
        <h2 class="page-header__title">{{ "dashboard" | translate }}</h2>
        <span class="page-header__subtitle">{{
          "dashboardSubtitle" | translate
        }}</span>
      </div>

      <div class="page-header__actions"></div>
    </div>
  </div>
</div>

<div class="page-container dashboard">
  <div class="page-content">
    <nz-spin [nzSpinning]="isLoading">
      <nz-row [nzGutter]="16" *ngIf="dashboardData">
        <nz-col [nzSpan]="6" *ngIf="isAdmin || isSysAdmin">
          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfOrganisationUsers"
              [nzTitle]="'numberOfOrganisationUsers' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfFamilies"
              [nzTitle]="'numberOfFamilies' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfMembers"
              [nzTitle]="'numberOfMembers' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfDonations"
              [nzTitle]="'numberOfDonations' | translate"            >
            </nz-statistic>
          </nz-card>
        </nz-col>

        <nz-col [nzSpan]="6" *ngIf="isAdmin || isSysAdmin">
          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids02"
              [nzTitle]="'numberOfKids02' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids35"
              [nzTitle]="'numberOfKids35' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids612"
              [nzTitle]="'numberOfKids612' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids1214"
              [nzTitle]="'numberOfKids1214' | translate"
            >
            </nz-statistic>
          </nz-card>
        </nz-col>
        <nz-col [nzSpan]="6" *ngIf="isAdmin || isSysAdmin">
          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids014"
              [nzTitle]="'numberOfKids014' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids016"
              [nzTitle]="'numberOfKids016' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids017"
              [nzTitle]="'numberOfKids017' | translate"
            >
            </nz-statistic>
          </nz-card>

          <nz-card>
            <nz-statistic
              [nzValue]="dashboardData.numberOfKids018"
              [nzTitle]="'numberOfKids018' | translate"
            >
            </nz-statistic>
          </nz-card>
        </nz-col>
      </nz-row>
    </nz-spin>
  </div>
  <div class="logo">
    <img src="/../../assets/images/logoVektor.png" />
  </div>
</div>

<!-- <app-spinner *ngIf="isLoading"></app-spinner> -->
